module.exports = __webpack_public_path__ + "static/media/me.32901374.svg";